<script>
  import {getContext} from 'svelte';
  import {numUtil} from '@/helper/num';
  import {refresh$} from '../stream';
  import lang from '../TradeCompetitionPage.lang';

  export let endTime;

  const LG = getContext('LG');
  const counter = {
    target: null,
    isTimeUp() {
      const now = Date.now();
      const leftTime = this.target - now;
      return leftTime <= 0;
    },
    cal() {
      const now = Date.now();
      let leftTime = this.target - now;
      const dayCount = ~~(leftTime / (1000 * 60 * 60 * 24));
      leftTime = leftTime - dayCount * (1000 * 60 * 60 * 24);
      const leftHour = ~~(leftTime / (1000 * 60 * 60));
      leftTime = leftTime - leftHour * (1000 * 60 * 60);
      const leftMinute = ~~(leftTime / (1000 * 60));
      leftTime = leftTime - leftMinute * (1000 * 60);
      const leftSecond = ~~(leftTime / 1000);
      data = {
        day: dayCount,
        hour: leftHour,
        minute: leftMinute,
        second: leftSecond,
      };
    },
    start(endTime) {
      if (endTime) {
        this.target = endTime;
        const interval = setInterval(() => {
          counter.cal();
          if (this.isTimeUp()) {
            clearInterval(interval);
            refresh$.next();
          }
        }, 1000);
      }
    },
  };
  let data = {
    day: 0,
    hour: 0,
    minute: 0,
    second: 0,
  };
  $: counter.start(endTime);
</script>

<style>
  .count-down {
    display: flex;
    align-items: baseline;
    font-size: 40px;
  }
  .count-down-sub {
    padding: 0 10px;
    font-size: 14px;
  }
  .count-down-label {
    font-weight: bold;
  }
  .count-down-label span {
    font-size: 30px;
  }
  @media screen and (min-width: 640px) {
    .count-down {
      justify-content: flex-end;
    }
  }
  @media screen and (max-width: 640px) {
    .count-down {
      justify-content: flex-start;
    }
  }
</style>

<div class="count-down">
  <div class="count-down-label">{data.day}</div>
  <div class="count-down-sub">{LG(lang.Day)}</div>
  <div class="count-down-label">
    {numUtil.pad(data.hour)}
    <span>:</span>
    {numUtil.pad(data.minute)}
    <span>:</span>
    {numUtil.pad(data.second)}
  </div>
</div>
